export default {
  namespaced: true,
  state: {
    loading: false,
    loaded: false,
    errored: false,
    message: '',
    loading2: false,
    loaded2: false,
    errored2: false,
    message2: '',
    dismissSuccessCountDown: 0,
    isConnected: false,
  },

  mutations: {

    setLoading(state, payload) {
        state.loading = payload;
        state.loaded = !payload;
        state.errored = false;
    },

    setLoading2(state, payload) {
        state.loading2 = payload;
        state.loaded2 = !payload;
        state.errored2 = false;
    },

    setLoaded(state, payload) {
        state.loaded = payload;
        state.loading = !payload;
    },

    setLoaded2(state, payload) {
        state.loaded2 = payload;
        state.loading2 = !payload;
    },

    setErrored(state, payload) {
        state.errored = payload;
        state.loading = false;
    },

    setErrored2(state, payload) {
        state.errored2 = payload;
        state.loading2 = false;
    },

    setMessage(state, payload) {
        state.message = payload;
    },

    setMessage2(state, payload) {
        state.message2 = payload;
    },
    
    setDismissSuccessCountDown(state, count) {
        state.dismissSuccessCountDown = count;
    },
    setIsConnected(state, isConnected) {
        state.isConnected = isConnected;
    },

  },

  actions: {

    setLoading({ commit }, loading) {
        commit('setLoading', loading);
    },

    setLoading2({ commit }, loading) {
        commit('setLoading2', loading);
    },

    setLoaded({ commit }, loaded) {
        commit('setLoaded', loaded);
    },

    setLoaded2({ commit }, loaded) {
        commit('setLoaded2', loaded);
    },

    setErrored({ commit }, errored) {
        commit('setErrored', errored);
    },

    setErrored2({ commit }, errored) {
        commit('setErrored2', errored);
    },

    setMessage({ commit }, message) {
        commit('setMessage', message);
    },

    setMessage2({ commit }, message) {
        commit('setMessage2', message);
    },

    setDismissSuccessCountDown({ commit }, dismissSuccessCountDown) {
        commit('setDismissSuccessCountDown', dismissSuccessCountDown);
    },
    setIsConnected({ commit }, isConnected) {
        commit('setIsConnected', isConnected);
    },
    
  },
};
